module.exports = __webpack_public_path__ + "static/img/center-1-bg.630ffba6.png";